// src/data/binCleaning.js
import {
  Trash2,
  Droplets,
  ShieldCheck,
  Wind,
  Leaf,
  Recycle,
  Truck,
  Building2,
} from 'lucide-react';

export const binCleaningFeatures = [
  {
    icon: Droplets,
    title: 'Deep Cleaning',
    description: 'A thorough clean covering every internal surface of your bin.',
  },
  {
    icon: Wind,
    title: 'High-Temperature Washing',
    description: 'Washed at approximately 90°C to help remove grime, dirt and bacteria.',
  },
  {
    icon: ShieldCheck,
    title: 'Sanitising',
    description: 'Kills bacteria and neutralises contaminants for a hygienic finish.',
  },
  {
    icon: Leaf,
    title: 'Deodorising',
    description: 'Eco-friendly, biodegradable products leave bins fresh and odour-free.',
  },
  {
    icon: Recycle,
    title: 'Responsible Wastewater Disposal',
    description: 'Wastewater handled responsibly, often under trade effluent consent.',
  },
  {
    icon: Truck,
    title: 'Kerbside Service',
    description: 'Convenient kerbside clean — bins returned neatly to your property.',
  },
  {
    icon: Trash2,
    title: 'Domestic & Commercial',
    description: 'Suitable for household wheelie bins and larger commercial bins.',
  },
  {
    icon: Building2,
    title: 'Suitable for 120L–1100L',
    description: 'We clean standard domestic and commercial wheelie bin sizes.',
  },
];

export const binCleaningPrices = [
  {
    id: 'one-bin',
    category: 'domestic',
    name: '1 Bin',
    price: '£9.99',
    unit: 'per clean',
    description: 'Single domestic wheelie bin',
    sizes: '120L – 240L',
  },
  {
    id: 'two-bins',
    category: 'domestic',
    name: '2 Bins',
    price: '£17.98',
    unit: 'per clean',
    description: 'Two domestic wheelie bins',
    sizes: '120L – 240L',
  },
  {
    id: 'three-bins',
    category: 'domestic',
    name: '3 Bins',
    price: '£24.98',
    unit: 'per clean',
    description: 'Three domestic wheelie bins',
    sizes: '120L – 240L',
  },
  {
    id: 'one-off',
    category: 'domestic',
    name: 'One-Off Clean',
    price: '£9.99',
    unit: 'per bin',
    description: 'Ideal for occasional maintenance or first-time customers',
    sizes: '120L – 240L',
    badge: 'Single Visit',
  },
  {
    id: 'subscription',
    category: 'domestic',
    name: 'Monthly Subscription',
    price: '£6.99',
    unit: 'per bin / month',
    description: 'Recurring monthly service for year-round hygiene',
    sizes: '120L – 240L',
    badge: 'Best Value',
    popular: true,
  },
  {
    id: 'commercial',
    category: 'commercial',
    name: 'Commercial Bins',
    price: '£15.50',
    unit: 'per bin',
    description: 'Larger bins for businesses and commercial premises',
    sizes: '360L – 1100L',
    badge: 'Commercial',
  },
];

export const binCleaningBenefits = [
  {
    icon: ShieldCheck,
    title: 'Hygienic Bins',
    description: 'Regular cleaning keeps your bins hygienic year-round.',
  },
  {
    icon: Wind,
    title: 'Reduced Odours',
    description: 'Reduces unpleasant odours that build up over time.',
  },
  {
    icon: Trash2,
    title: 'Helps Prevent Pests',
    description: 'Helps prevent pest infestations attracted to dirty bins.',
  },
  {
    icon: Leaf,
    title: 'Year-Round Freshness',
    description: 'Subscription plans keep your bins consistently fresh.',
  },
];